import RecentActivityRentalCar from'./RecentActivityRentalCar';export default RecentActivityRentalCar;
//# sourceMappingURL=index.js.map